<template>
    <div>
        <div class="content-caption dashed">
            <span>单据信息</span>
        </div>
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label>单据类型：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ esignBizForm.bizTypeName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>单据编号：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ esignBizForm.bizVoucherNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>甲方公司：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ esignBizForm.fstPartyRealComName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>乙方公司：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ esignBizForm.sndPartyRealComName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>待签署文件：</label>
                </div>
                <div class="form-value width-1-5x">
                    {{ esignBizForm.fileToSignGenerated == false ? '未生成' : '' }}
                    <a class="font-blue" v-if="esignBizForm.fileToSignGenerated == true" @click="toGenFile">查看</a>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>上传状态：</label>
                </div>
                <div class="form-value width-1-5x">
                    {{ esignBizForm.fileToSignStatusDesc }}
                </div>
            </div>
        </div>

        <div class="content-caption dashed">
            <span>签署方信息</span>
        </div>
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label>发起人手机号：</label>
                </div>
                <div class="form-value width-1-5x">
                    {{ esignBizForm.initiatorPhoneNo }}
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发起人认证状态：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span> {{ esignAuthenStateMap[esignBizForm.initiatorAuthenState] }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>签署顺序：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ esignBizForm.sndPartySignFirst == true ? '乙方先签' : '甲方先签' }}</span>
                </div>
            </div>
            <div class="form-group center">
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>甲方自动签署：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ esignBizForm.fstPartyAutoSign == true ? '是' : '否' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>乙方自动签署：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ esignBizForm.sndPartyAutoSign == true ? '是' : '否' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label v-if="esignBizForm.fstPartyAutoSign==true">甲方签署印章：</label>
                </div>
                <div class="form-value width-1-5x">
                    <div v-if="esignBizForm.fstPartyAutoSign==true">
                        <div>{{ esignBizForm.fstEsignDefSealName || '' }}</div>
                        <img style="width: 100px;height: 100px;" :src="esignBizForm.fstEsignDefSealImageUrl" @click="showSealImage(esignBizForm.fstEsignDefSealImageUrl)"/>
                    </div>
                </div>

            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label v-if="esignBizForm.sndPartyAutoSign==true">乙方签署印章：</label>
                </div>
                <div class="form-value width-1-5x">
                    <div v-if="esignBizForm.sndPartyAutoSign==true">
                        <div>{{ esignBizForm.sndEsignDefSealName || '' }}</div>
                        <img style="width: 100px;height: 100px;" :src="esignBizForm.sndEsignDefSealImageUrl" @click="showSealImage(esignBizForm.sndEsignDefSealImageUrl)"/>
                    </div>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>甲方公司：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ esignBizForm.fstPartyRealComName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>乙方公司：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ esignBizForm.sndPartyRealComName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>甲方公司认证状态：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span> {{ esignAuthenStateMap[esignBizForm.fstPartyOrgAuthState] }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>乙方公司认证状态：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span> {{ esignAuthenStateMap[esignBizForm.sndPartyOrgAuthState] }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label v-if="esignBizForm.fstPartyAutoSign==false">甲方签署人手机号：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span v-if="esignBizForm.fstPartyAutoSign==false">{{ esignBizForm.fstPartyTransactorPhoneNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>乙方签署人手机号：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span> {{ esignBizForm.sndPartyTransactorPhoneNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label v-if="esignBizForm.fstPartyAutoSign==false">甲方签署人认证状态：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span v-if="esignBizForm.fstPartyAutoSign==false"> {{ esignAuthenStateMap[esignBizForm.fstPartyTransactorAuthenState] }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>乙方签署人认证状态：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span> {{ esignAuthenStateMap[esignBizForm.sndPartyTransactorAuthenState] }}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>签署结果</span>
        </div>
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label>签署状态：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ signFlowStatusMap[esignBizForm.signFlowStatus] }}</span>
                    <a class="el-icon-refresh" v-if="esignBizForm.signFlowStatus == 1" @click="refreshSignFlowStatus"></a>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>签署日期：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span v-if="esignBizForm.signFlowStatus == 2">{{ esignBizForm.signFlowEndTime }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>已签署文件：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span v-if="esignBizForm.signedFileUuid == null">暂无</span>
                    <a class="font-blue" v-if="esignBizForm.signedFileUuid != null" @click="toViewFile(esignBizForm.signedFileUuid)">下载</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { Utils } from '../../app.base'
import { Vue, MsgBox, Routes } from '../../app.vues'

import { openGoodsOrderInfoForPdf } from './dialog'
import esignBizFormApi from '../../api/esignBizForm';

export default {
    name: 'swb-esign-biz-form-info-view',
    avlActions: '',
    avlScopes: 'retailer',
    notAsResc: true,
    authen: false,
    desc: '签署单详情',
    props: ['id'],
    data: function () {
        return {
            esignBizForm: {},
            esignAuthenStateMap: getEnumMap('esignAuthenState', 'value2text'),
            signFlowStatusMap: getEnumMap('esignSignFlowState', 'value2text')
        }
    },
    created: function () {
        this.getEsignBizFormById()
    },
    methods: {
        getEsignBizFormById: function () {
            let self = this;
            let theLoad = MsgBox.loading();
            esignBizFormApi.getEsignBizFormById({id: this.id}, function (result) {
                theLoad.hide();
                self.esignBizForm = result.data
            })
        },
        refreshSignFlowStatus: function () {
            let self = this
            let msgBoxDlg = MsgBox.loading();
            esignBizFormApi.refreshSignFlowStatus({id: this.id}, function (result) {
                msgBoxDlg.close()
                if(result.type == 'info') {
                    self.$message.success('已刷新');
                    self.getEsignBizFormById();
                } else {
                    MsgBox.warning(result.message)
                }
            })
        },
        toViewFile: function (fileUuid) {
            // let url = appConf.makeViewAsPdfUrl(uuid)
            // Utils.setPageUrl(url, '_blank');
            let url = getAppUrl('/file/download?uuid=' + fileUuid)
            Utils.downloadFile(url);
        },
        toGenFile: function () {
            let self = this
            openGoodsOrderInfoForPdf(this.esignBizForm.bizVoucherId, function () {
                self.getEsignBizFormById();
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/order/EsignBizFormInfoView.vue